import { captureException } from '@sentry/nextjs'

export function decodeBase64Url(value: string): string {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/')

    if (normalized.length % 4 === 1) {
        captureException(new Error(`[decode-base-64-fail]: normalized length is not divisible by 4`), {
            extra: {
                value,
                normalized,
            },
        })

        throw new Error('Invalid base64Url string')
    }

    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')

    if (typeof window === 'undefined') {
        return Buffer.from(padded, 'base64').toString('utf-8')
    }

    const binary = window.atob(padded)
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))

    return new TextDecoder('utf-8').decode(bytes)
}
